/**
 * 画像を指定スケールにリサイズする（無料プラン保存・DL用）
 */
export const downscaleImage = async (
  imageUrl: string,
  scale: number = 0.5
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      reject(new Error('Canvas context not available'));
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      const canvasWidth = Math.floor(img.width * scale);
      const canvasHeight = Math.floor(img.height * scale);

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);

      resolve(canvas.toDataURL('image/png', 0.9));
    };

    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };

    img.src = imageUrl;
  });
};

/** @deprecated 透かしは廃止。downscaleImage を使用してください。 */
export const addWatermarkToImage = async (
  imageUrl: string,
  _watermarkText: string = 'P',
  isLowResolution: boolean = false
): Promise<string> => {
  if (isLowResolution) {
    return downscaleImage(imageUrl, 0.5);
  }
  return imageUrl;
};
